/**
 * Размер картинки в пикселях — чтобы решить, мелкая ли она (`isSmallImage`).
 *
 * У `Image` в GraphQL ширины и высоты нет, поэтому сохранённую картинку меряем на
 * клиенте. Для замера CORS не нужен: `naturalWidth` у `<img>` доступен и без
 * `crossOrigin` — в отличие от чтения пикселей, для которого картинку придётся скачать.
 */

import { ImageSize, decodeImage } from 'shared/utils/image/image-canvas';
import { UpscaleImageError } from 'shared/utils/image/upscale/upscale-error';

function measureUrl(url: string): Promise<ImageSize> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve({ width: image.naturalWidth, height: image.naturalHeight });
    image.onerror = () => reject(new UpscaleImageError('decode', `Картинка не загрузилась: ${url}`));
    image.src = url;
  });
}

/** Файл — через `decodeImage` (с EXIF-поворотом, как его увидит канва), адрес — через `<img>`. */
export async function measureImage(source: File | string): Promise<ImageSize> {
  if (typeof source === 'string') return measureUrl(source);

  let image;
  try {
    image = await decodeImage(source);
  } catch (error) {
    throw new UpscaleImageError('decode', (error as Error).message);
  }

  try {
    return { width: image.width, height: image.height };
  } finally {
    image.close();
  }
}
